import { Reveal } from "./Reveal";

export default function PageHero({ label, title, highlight, description, testid }) {
    return (
        <section
            data-testid={testid}
            className="relative overflow-hidden pt-32 md:pt-44 pb-10 md:pb-14"
        >
            <div className="pointer-events-none absolute -top-40 -left-40 w-[440px] h-[440px] rounded-full bg-[#DCEAFF] blur-[120px]" />
            <div className="pointer-events-none absolute top-10 -right-40 w-[380px] h-[380px] rounded-full bg-[#D9F3FD] blur-[120px]" />
            <div
                className="pointer-events-none absolute inset-0 bg-grid-light"
                aria-hidden="true"
            />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
                <Reveal>
                    <span className="text-xs uppercase tracking-[0.25em] text-[#1E56FF] font-bold">
                        {label}
                    </span>
                    <h1 className="font-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0F1B3D] max-w-3xl">
                        {title} {highlight && <span className="text-gradient">{highlight}</span>}
                    </h1>
                    <p className="mt-5 text-sm md:text-lg text-[#5B6B8C] leading-relaxed max-w-2xl">
                        {description}
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
